import React, { useState, useEffect, useRef } from "react";
import OverlayContainer from "@components/Overlay/OverlayContainer";
import { courseService } from "../../../_services";
import { emailVaildation } from "../../../_helpers";
import { timeZone } from "../../../_constants/staticData";
import "./contactsales.scss";

const TOTAL_SLIDES = 1;

const ContactSales = ({ closeHandler, handleManageOverlay }) => {
  const initialState = {
    FullName: "",
    Email: "",
    Telephone: "",
    CompanyName: "",
    DescribeYourself: "",
    JobTitle: "",
    OperatingModel: "",
    ProductsInterestedIn: "",
    TimeZone: "",
    PreferredTime: "",
  };

  const [current, setCurrent] = useState(0);
  const [ContactForm, setContactForm] = useState(initialState);
  const [error, setError] = useState(false);
  const ref = useRef(null);
  const ValidateEmail = emailVaildation(ContactForm.Email) ? true : false;
  const next = () => {
    setError(true);
    if (
      ContactForm.FullName === "" ||
      ContactForm.Email === "" ||
      ContactForm.Telephone === "" ||
      ContactForm.CompanyName === "" ||
      ContactForm.DescribeYourself === "" ||
      ValidateEmail === false
    ) {
      setCurrent(0);
    } else {
      if (current >= TOTAL_SLIDES) return;
      else setCurrent(current + 1);
    }
  };

  const prev = () => {
    if (current === 0) return;
    else setCurrent(current - 1);
  };

  const handleInputChange = (e) => {
    setContactForm({ ...ContactForm, [e.target.name]: e.target.value });
  };

  async function postContactForm() {
    courseService
      .postContactDetail(ContactForm)
      .then((response) => console.log(response));
  }

  const handleSubmit = (e) => {
    e.preventDefault();
    setError(true);
    if (
      ContactForm.FullName === "" ||
      (ContactForm.Email === "" && ValidateEmail === false) ||
      ContactForm.Telephone === "" ||
      ContactForm.CompanyName === "" ||
      ContactForm.DescribeYourself === "" ||
      ContactForm.OperatingModel === "" ||
      ContactForm.ProductsInterestedIn === "" ||
      ContactForm.TimeZone === "" ||
      ContactForm.PreferredTime === ""
    )
      return;
    else {
      postContactForm();
      closeHandler();
      handleManageOverlay(ContactForm);
    }
  };

  useEffect(() => {
    ref.current.style.transition = "all 0.2s ease-in-out";
    ref.current.style.transform = `translateX(-${current}00%)`;
  }, [current]);

  return (
    <>
        <div className="inner-overlay book-demo">
          <div className="close-wrapper" onClick={() => closeHandler()}>
            <div>
              <i className="icon check" />
            </div>
          </div>
          <div className="wrapper">
            <div className="frame">
              <h3 className="request-heading">CONTACT SALES</h3>
              <form action="" onSubmit={handleSubmit}>
                <div className="box-container" ref={ref}>
                  <div className="main-box">
                    <div className="form-main">
                      <div className="form-wrapper">
                        <div
                          className={`form-wrap ${
                            ContactForm.FullName === "" && error === true
                              ? "form-error"
                              : ""
                          }`}
                        >
                          <label className="control-label ">Full Name</label>
                          <input
                            type="text"
                            name="FullName"
                            id="FullName"
                            autoComplete="off"
                            placeholder="Full Name"
                            className={`form-control ${
                              ContactForm.FullName === "" &&
                              error === true &&
                              "error"
                            }`}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div
                          className={`form-wrap ${
                            ContactForm.Email === "" && error === true
                              ? "form-error"
                              : ""
                          }`}
                        >
                          <label className="control-label ">Email</label>
                          <input
                            type="text"
                            name="Email"
                            autoComplete="off"
                            id="Email"
                            placeholder="Email"
                            className={`form-control ${
                              ContactForm.Email === "" &&
                              error === true &&
                              "error"
                            }`}
                            onChange={handleInputChange}
                          />
                          <p className="error-text">{`${
                            !ValidateEmail &&
                            ContactForm.Email !== "" &&
                            error === true
                              ? "Please enter valid email"
                              : ""
                          }`}</p>
                        </div>
                      </div>

                      <div className="form-wrapper">
                        <div
                          className={`form-wrap ${
                            ContactForm.Telephone === "" && error === true
                              ? "form-error"
                              : ""
                          }`}
                        >
                          <label className="control-label ">
                            Telephone Number
                          </label>
                          <input
                            type="number"
                            name="Telephone"
                            id="Telephone"
                            autoComplete="off"
                            placeholder="Phone Number"
                            className={`form-control ${
                              ContactForm.Telephone === "" &&
                              error === true &&
                              "error"
                            }`}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div
                          className={`form-wrap ${
                            ContactForm.CompanyName === "" && error === true
                              ? "form-error"
                              : ""
                          }`}
                        >
                          <label className="control-label ">
                            CompanyName Name
                          </label>
                          <input
                            type="text"
                            name="CompanyName"
                            id="CompanyName"
                            autoComplete="off"
                            placeholder="Company Name"
                            className={`form-control ${
                              ContactForm.CompanyName === "" &&
                              error === true &&
                              "error"
                            }`}
                            onChange={handleInputChange}
                          />
                        </div>
                      </div>

                      <div className="form-wrapper">
                        <div
                          className={`form-wrap ${
                            ContactForm.DescribeYourself === "" &&
                            error === true
                              ? "form-error"
                              : ""
                          }`}
                        >
                          <label className="control-label ">
                            What DescribeYourselfs you best ?
                          </label>
                          <input
                            type="text"
                            name="DescribeYourself"
                            id="DescribeYourself"
                            autoComplete="off"
                            placeholder=" What Describes you best ?"
                            className={`form-control ${
                              ContactForm.DescribeYourself === "" &&
                              error === true &&
                              "error"
                            }`}
                            onChange={handleInputChange}
                          />
                        </div>

                        <div className="form-wrap">
                          <label className="control-label ">Title/Role</label>
                          <div className="styled-select">
                            <select
                              defaultValue=""
                              name="JobTitle"
                              id="title"
                              className={"form-control "}
                              onChange={handleInputChange}
                            >
                              <option value="" disabled hidden>
                                Job title (optional)
                              </option>
                              <option value="Instructor">Instructor</option>
                              <option value="Instructor Assistant">
                                Instructor
                              </option>
                              <option value="Mentor">Mentor</option>
                              <option value="Online ESL Instructor">
                                Online ESL Instructor
                              </option>
                              <option value="Professor">Professor</option>

                              <option value="Administrator">
                                Administrator
                              </option>
                              <option value="Admin Assistant">
                                Admin Assistant
                              </option>
                              <option value="Academic / Researcher">
                                Academic / Researcher
                              </option>
                              <option value="Business Owner">
                                Business Owner
                              </option>
                              <option value="Other ">Other </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="form-wrapper">
                        <button
                          className="cancel-btn"
                          type="cancel"
                          onClick={() => closeHandler()}
                        >
                          CANCEL REQUEST
                        </button>

                        <button onClick={next} className="request-btn">
                          CONTINUE NEXT
                        </button>
                      </div>
                    </div>
                  </div>
                  <div className="main-box">
                    {" "}
                    <div>
                      <div className="form-wrapper">
                        <div
                          className={`form-wrap ${
                            ContactForm.OperatingModel === "" && error === true
                              ? "form-error"
                              : ""
                          }`}
                        >
                          <label className="control-label ">
                            Operating Model
                          </label>
                          <div className="styled-select">
                            <select
                              name="OperatingModel"
                              id="OperatingModel"
                              className={`form-control ${
                                ContactForm.OperatingModel === "" &&
                                error === true &&
                                "error"
                              }`}
                              onChange={handleInputChange}
                            >
                              <option value="Operating Model">
                                Operating Model
                              </option>
                              <option value="Instructor">Instructor</option>
                              <option value="Individual">Individual</option>
                              <option value="Trade School">Trade School</option>
                              <option value="High School">High School</option>
                              <option value="University ">University</option>
                              <option value="College or Institute">
                                College or Institute
                              </option>
                              <option value="Non Profit ">Non Profit</option>
                              <option value="Government ">Government</option>
                              <option value="Business ">Business</option>
                              <option value="other ">other</option>
                            </select>
                          </div>
                        </div>

                        <div
                          className={`form-wrap ${
                            ContactForm.ProductsInterestedIn === "" &&
                            error === true
                              ? "form-error"
                              : ""
                          }`}
                        >
                          <label className="control-label ">
                            Product Intersted in
                          </label>
                          <div className="styled-select">
                            <select
                              name="ProductsInterestedIn"
                              id="ProductsInterestedIn"
                              className={`form-control ${
                                ContactForm.ProductsInterestedIn === "" &&
                                error === true &&
                                "error"
                              }`}
                              onChange={handleInputChange}
                            >
                              <option value="Product Intersted inl">
                                Product Intersted in
                              </option>

                              <option value="White Label">White Label</option>
                              <option value="Hosted White Labelt ">
                                Hosted White Label
                              </option>
                              <option value="Licensed ">Licensed</option>
                              <option value="other ">other</option>
                            </select>
                          </div>
                        </div>
                      </div>

                      <div className="form-wrapper">
                        <div
                          className={`form-wrap ${
                            ContactForm.TimeZone === "" && error === true
                              ? "form-error"
                              : ""
                          }`}
                        >
                          <label className="control-label ">Time Zone</label>
                          <div className="styled-select">
                            <select
                              name="TimeZone"
                              className={`form-control ${
                                ContactForm.TimeZone === "" &&
                                error === true &&
                                "error"
                              }`}
                              onChange={handleInputChange}
                            >
                              <option>Your Time Zone</option>
                              {timeZone.map((t) => (
                                <option value={t.value}>{t.label}</option>
                              ))}
                            </select>
                          </div>
                        </div>

                        <div
                          className={`form-wrap ${
                            ContactForm.PreferredTime === "" && error === true
                              ? "form-error"
                              : ""
                          }`}
                        >
                          <label className="control-label ">
                            Preferred Time to Call
                          </label>
                          <div className="styled-select">
                            <select
                              name="PreferredTime"
                              id="PreferredTime"
                              className={`form-control ${
                                ContactForm.PreferredTime === "" &&
                                error === true &&
                                "error"
                              }`}
                              onChange={handleInputChange}
                            >
                              <option value="  Preferred Time to Call">
                                Preferred Time to Call
                              </option>

                              <option value="1:00 to 2:00">1:00 to 2:00</option>
                              <option value="2:00 to 3:00 ">
                                2:00 to 3:00
                              </option>
                              <option value="3:00 to 4:00">3:00 to 4:00</option>
                              <option value="4:00 to 5:00 ">
                                4:00 to 5:00
                              </option>
                              <option value="5:00 to 6:00">5:00 to 6:00</option>
                              <option value="6:00 to 7:00 ">
                                6:00 to 7:00
                              </option>
                              <option value="7:00 to 8:00">7:00 to 8:00</option>
                              <option value="8:00 to 9:00 ">
                                8:00 to 9:00
                              </option>
                              <option value="9:00 to 10:00">
                                9:00 to 10:00
                              </option>
                              <option value="10:00 to 11:00 ">
                                10:00 to 11:00
                              </option>
                            </select>
                          </div>
                        </div>
                      </div>
                      <div className="fine-print flex">
                        <input id="consent" type="checkbox" />
                        <label>
                          I consent to get news, product and service updates
                          from yslearn (optional).
                        </label>
                      </div>
                      <div className="form-wrapper">
                        <button className="cancel-btn" onClick={prev}>
                          EDIT INFO
                        </button>

                        <button className="request-btn" type="submit">
                          SUBMIT
                        </button>
                      </div>
                      <div className="fine-print">
                        <label>
                          By signing up you accept our <b> privacy policy</b>.
                          your contact information can be used with in yslearn
                          and will never shared or sold with third parties
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
    </>
  );
};

export default ContactSales;
